// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7650":"b277ccc1","7694":"1b78d227","8791":"3df96505"}[chunkId] + ".chunk.css";
};